import React from 'react';
import { Editor } from 'slate';
import { Plugin, CustomEditor, CustomText } from '../types';

const FontPlugin: Plugin = {
  name: 'font',
  
  commands: {
    setFontFamily: (editor: CustomEditor, fontFamily: string) => {
      Editor.addMark(editor, 'fontFamily', fontFamily);
    },
    
    setFontSize: (editor: CustomEditor, fontSize: number) => {
      Editor.addMark(editor, 'fontSize', fontSize);
    }
  }
};

export default FontPlugin; 